import api from './index'
import { axios } from '@/utils/request'

export function createTab(parameter) {
  return axios({
    url: api.BaseURL + api.Tab + 'create',
    method: 'POST',
    data: parameter
  })
}

export function getListTab(parameter) {
  return axios({
    url: api.BaseURL + api.Tab + 'list',
    method: 'GET',
    params: parameter
  })
}

export function updateTab(parameter) {
  return axios({
    url: api.BaseURL + api.Tab + 'update',
    method: 'POST',
    data: parameter
  })
}

export function deleteTab(parameter) {
  return axios({
    url: api.BaseURL + api.Tab + 'delete',
    method: 'POST',
    data: parameter
  })
}